import script from "./nav-back.vue?vue&type=script&setup=true&lang=js"
export * from "./nav-back.vue?vue&type=script&setup=true&lang=js"

import "./nav-back.vue?vue&type=style&index=0&id=0c4bdeda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c4bdeda"]])

export default __exports__